// no $m: marks the contents entry of the section being read, and at phone
// width slides the contents over the page from the top bar's button, as the
// signed-in Sidebar does. The page reads the same without it.
const shell = document.getElementById('shell');
const side = document.getElementById('shellSide');
const menu = document.getElementById('shellMenu');
const scrim = document.getElementById('shellScrim');
const links = [...document.querySelectorAll<HTMLAnchorElement>('.policy-toc a[href^="#"]')];
const sections = links
    .map(link => document.getElementById(link.hash.slice(1)))
    .filter((section): section is HTMLElement => section !== null);

function markReading(id: string): void {
    for (const link of links) {
        link.setAttribute('aria-current', String(link.hash === '#' + id));
    }
}

// the topmost section crossing the band near the top of the viewport
const inView = new Set<string>();
const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
        if (entry.isIntersecting) {
            inView.add(entry.target.id);
        } else {
            inView.delete(entry.target.id);
        }
    }
    const current = sections.find(section => inView.has(section.id));
    if (current) {
        markReading(current.id);
    }
}, { rootMargin: '-15% 0px -70% 0px' });
sections.forEach(section => observer.observe(section));

// the last section is short: at the foot of the page it is the one being read
const last = sections.at(-1);
addEventListener('scroll', () => {
    if (last && innerHeight + scrollY >= document.documentElement.scrollHeight - 4) {
        markReading(last.id);
    }
}, { passive: true });

// the drawer: phone and narrow tablet only, out of the tab order while shut
const narrow = matchMedia('(max-width: 56rem)');
const isOpen = (): boolean => shell?.hasAttribute('data-open') ?? false;

function syncDrawer(): void {
    if (side) {
        side.inert = narrow.matches && !isOpen();
    }
}

function setDrawer(on: boolean): void {
    shell?.toggleAttribute('data-open', on);
    menu?.setAttribute('aria-expanded', String(on));
    if (scrim) {
        scrim.hidden = !on;
    }
    syncDrawer();
}

menu?.addEventListener('click', () => {
    setDrawer(!isOpen());
    if (isOpen()) {
        links[0]?.focus();
    }
});
scrim?.addEventListener('click', () => setDrawer(false));
narrow.addEventListener('change', () => setDrawer(false));
document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && isOpen()) {
        setDrawer(false);
        menu?.focus();
    }
});

// a phone reader picking a section wants the text, not the list
for (const link of links) {
    link.addEventListener('click', () => {
        if (narrow.matches) {
            setDrawer(false);
        }
    });
}
syncDrawer();
